import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PaymentMethodEnum, ProviderEnum } from '@/types/common';

import { AdyenPayForm } from './AdyenPayForm';
import { StripeGenericPayForm } from './StripeGenericPayForm';
import { PaymentMethodsToStripe } from '@/constants/stripe';

export const KlarnaForm = () => {
  const { paymentMethodsSettings } = useContext(CheckoutContext);
  const providerSettings = paymentMethodsSettings.find(
    (paymentMethod) => paymentMethod.paymentMethodName === PaymentMethodEnum.KLARNA
  );

  if (providerSettings?.provider === ProviderEnum.STRIPE) {
    return <StripeGenericPayForm paymentMethod={PaymentMethodsToStripe[PaymentMethodEnum.KLARNA]} />;
  }
  if (providerSettings?.provider === ProviderEnum.ADYEN) {
    return <AdyenPayForm selectedPaymentMethod={PaymentMethodEnum.KLARNA} />;
  }

  return null;
};
